'use strict';
/* Controllers for the autoremind.logs feature */
import { PatientsActions } from "../../../../../ngapp/src/app/reminders/patients/state/patients.actions";
import { AppointmentListActions } from "../../../../../ngapp/src/app/reminders/appointment-list/state/appointment-list.actions";
import { MessageActions } from "../../../../../ngapp/src/app/message-list/state/message.actions";
/**
 * Main screen controller for the logs screen
 */
var app = angular.module('autoremind.logs', []);
app
    .controller('autoremind.logs.ScreenController', 
// Setup dependencies
['$scope', 'logger', 'userProfile', 'angularMomentConfig', '$timeout', '$q', 'accountService', '$location', 'eventSharingService', 'patientsSelectorsDowngraded',
    'storeDowngraded',
    function ($scope, logger, userProfile, angularMomentConfig, $timeout, $q, accountService, $location, eventSharingService, patientsSelectorsDowngraded, storeDowngraded) {
        logger.info('In autoremind.logs.ScreenController');
        $scope.viewModel = {
            detailsVisible: true,
            selectedPatient: {
                destinators: []
            }
        };
        $scope.accountService = accountService;
        var subscribe;
        userProfile.getProfileIfNotLoaded(function () {
            logger.debug('SystemCheckController: got user profile');
            //$scope.systemcheckModel.timezone = userProfile.profileModel.timezone;
            //angularMomentConfig.timezone = userProfile.profileModel.tz;
        });
        userProfile.initalizeViewModel();
        if (!angular.isDefined(userProfile.viewModel.views.logs)) {
            // This is the first time opening the logs view, so initialize
            userProfile.viewModel.views.logs = {};
        }
        $scope.selectPatient = function (personId) {
            $scope.viewModel.selectedPatient = undefined;
            storeDowngraded.dispatch(PatientsActions.getSelectedPatient({ personId: personId }));
            patientsSelectorsDowngraded.selectSelectedPatient()
                .subscribe(function (response) {
                if (response) {
                    $scope.viewModel.selectedPatient = response;
                    $scope.viewModel.destinators = angular.copy($scope.viewModel.selectedPatient.destinators);
                }
            });
        };
        $scope.openSubscriptionsDialog = function (personId, destinator) {
            storeDowngraded.dispatch(PatientsActions.openSubscriptionsDialogFromLogs({ selectedDestinator: destinator, selectedPatient: $scope.viewModel.selectedPatient }));
            subscribe = patientsSelectorsDowngraded.selectIsSubscriptionUpdated()
                .subscribe(function (response) {
                if (response) {
                    storeDowngraded.dispatch(PatientsActions.getSelectedPatient({ personId: personId }));
                }
            });
        };
        $scope.setRouteNg2 = function (url, personid) {
            // Changing URL as its displaying encoded url in browser
            $location.url('/patients?patientid=' + personid);
            var params = {};
            params['patientid'] = personid;
            eventSharingService.setRoute(url, params);
        };
    }]);
/**
 * Controller for the reminder logs tab
 */
app
    .controller('autoremind.logs.ReminderLogsPaneController', 
// Setup dependencies
['$scope', '$http', '$location', '$filter', 'logger', 'userProfile', 'accountService', 'angularMomentConfig', '$enhancedHttp', 'storeDowngraded',
    function ($scope, $http, $location, $filter, logger, userProfile, accountService, angularMomentConfig, $enhancedHttp, storeDowngraded) {
        // Inizialize
        $scope.accountService = accountService;
        logger.info('In autoremind.logs.ReminderLogsPaneController');
        if (!angular.isDefined(userProfile.viewModel.views.logs.reminders)) {
            // This is the first time opening the logs reminder view, so initialize
            userProfile.viewModel.views.logs.reminders = {};
            userProfile.viewModel.views.logs.reminders.period = 'today';
            userProfile.viewModel.views.logs.reminders.date = null;
            userProfile.viewModel.views.logs.reminders.showDeletedNotifications = false;
            userProfile.viewModel.views.logs.reminders.reminders = [];
            userProfile.viewModel.views.logs.reminders.search = {};
            userProfile.viewModel.views.logs.reminders.search.destinator = '';
            //        userProfile.viewModel.views.logs.reminders.search.destinator_filtered = '';
            userProfile.viewModel.views.logs.reminders.fetchState = {
                "buttonLabel": "First Load",
                "busy": "false"
            };
            userProfile.viewModel.views.logs.reminders.selectedAppointment = null;
        }
        // Map shared view model to this view
        $scope.remindersModel = userProfile.viewModel.views.logs.reminders;
        // -------------------------
        $scope.myData = [{
                label: "UTC (wrong +1?)",
                value: "Etc/UTC"
            }, {
                label: "UTC (Africa/Monrovia)",
                value: "Africa/Monrovia"
            }, {
                label: "Copenhagen",
                value: "Europe/Copenhagen"
            }, {}, {
                label: "Sydney",
                value: "Australia/Sydney"
            }, {
                label: "Tasmania",
                value: "Australia/Sydney",
            }, {
                label: "EST5EDT",
                value: "EST5EDT"
            }, {
                label: "Amsterdam",
                value: "Europe/Amsterdam"
            }, {
                label: "Eastern Standard Time",
                value: "America/New_York"
            }, {
                label: "Pacific Daylight Time",
                value: "America/Los_Angeles"
            }, {
                label: "London",
                value: "Europe/London"
            }];
        //Preselect the first item in the array
        $scope.selectedItem = $scope.myData[5];
        $scope.formattedTime = '';
        $scope.timer = undefined;
        $scope.tempDate = undefined;
        $scope.selectTimezone = function () {
            angularMomentConfig.timezone = $scope.selectedItem.value;
        };
        //This function will pick up the selected item from the
        //drop down and display the corresponding time of the
        //time zone
        $scope.updateTime = function () {
            var strTz = $scope.selectedItem.value;
            $scope.tempNow = new Date();
            //tempDate.tz(timezone)//        $scope.$apply();
        };
        $scope.updateTime();
        //We will run the function updateTime every second
        setInterval(function () {
            $scope.$apply($scope.updateTime());
        }, 1000);
        $scope.amFilter = function (values) {
            if (typeof value === 'undefined' || value === null) {
                return '';
            }
            var strTz = $scope.selectedItem.value;
            //var tempDate = moment(value).tz(strTz);
            var tempDate = moment().tz(strTz);
            if (!tempDate.isValid()) {
                return '';
            }
            //var formattedTime = tempDate.format(format);
            var formattedTime = ""; //tempDate.format('MMMM Do YYYY, h:mm:ss a');
            return formattedTime;
        };
        // ------------------
        //$scope.period = 'today';
        //$scope.date = null;
        //$scope.showdeletednotifications = false;
        //$scope.reminders = [];
        $scope.pages = 1;
        $scope.page = 1;
        $scope.nextPageDate = '';
        $scope.nextPages = false;
        // --------------------
        /**
         * Open/close the date picker
         */
        $scope.toggleDatepicker = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.remindersModel.datepickerOpened = !$scope.remindersModel.datepickerOpened;
        };
        /**
         *
         */
        $scope.fetchRemindersByPeriod = function () {
            logger.debug('logs.ReminderLogsPaneController.fetchRemindersByPeriod() start ' + $scope.remindersModel.period);
            $scope.remindersModel.datepickerOpened = false;
            if ($scope.remindersModel.period === 'today') {
                $scope.remindersModel.date = new Date();
            }
            else {
                $scope.remindersModel.date = null; // Clear date field
            }
            $scope.fetchReminders();
        };
        /**
         *
         */
        $scope.fetchRemindersByDate = function () {
            logger.debug('logs.ReminderLogsPaneController.fetchRemindersByDate() start ' + $scope.remindersModel.date);
            $scope.remindersModel.period = 'none'; // Update drowndown to no period
            $scope.fetchReminders();
        };
        /**
         * This will fetch reminder logs from the server
         */
        $scope.fetchReminders = function (nextx) {
            $scope.remindersModel.fetchState.buttonLabel = 'Loading...';
            $scope.remindersModel.fetchState.busy = true;
            $scope.remindersModel.reminders = []; // Clear list in UI
            // TODO: move the server communication to a service
            $scope.urlroot = 'servlets/autoremind/logs/?';
            $scope.url = $scope.urlroot;
            // TODO: Change this to calculate start/end date and time
            if ($scope.remindersModel.date == null) {
                $scope.url = $scope.urlroot + "period=" + $scope.remindersModel.period;
            }
            else {
                //$scope.url = $scope.urlroot + "pick_date=" + $scope.remindersModel.date.getTime();
                $scope.url = $scope.urlroot + "date=" + $filter("date")($scope.remindersModel.date, 'yyyy-MM-dd');
            }
            //logger.debug('$scope.remindersModel.showDeletedNotifications=' + $scope.remindersModel.showDeletedNotifications);
            if ($scope.remindersModel.showDeletedNotifications === true) {
                $scope.url += "&showdeletednotifications=1";
            }
            $scope.remindersModel.statusDetails = false;
            if (($location.search()).statusdetails === 'true') {
                $scope.remindersModel.statusDetails = true;
                $scope.url += "&statusdetails=1";
                logger.debug('location.search.statusdetails=' + ($location.search()).statusdetails);
            }
            logger.debug('remindersModel.statusDetails=' + $scope.remindersModel.statusDetails);
            if (nextx) {
                $scope.url = $scope.url + "&nextpagedate=" + encodeURIComponent($scope.nextPageDate);
            }
            else {
                $scope.nextPages = false;
            }
            logger.debug('logs.ReminderLogsPaneController.fetchReminders() url=' + $scope.url);
            $enhancedHttp({ method: 'GET', url: $scope.url })
                .then(function (data, status) {
                $scope.remindersModel.fetchState.busy = false;
                $scope.remindersModel.fetchState.buttonLabel = 'Refresh';
                logger.debug('logs.ReminderLogsPaneController.fetchReminders() got data from server');
                for (var i = 0; i < data.messages.length; i++) {
                    data.messages[i].appointmentdate = $filter('amTestFilter')(data.messages[i].appointmentdatems, 'MM/DD/YYYY h:mm a');
                    for (var n = 0; n < data.messages[i].notifications.length; n++) {
                        data.messages[i].notifications[n].date = $filter('amTestFilter')(data.messages[i].notifications[n].datems, 'MM/DD/YYYY h:mm a');
                    }
                }
                $scope.remindersModel.reminders = data.messages;
                if (typeof data.nextpagedate !== 'undefined' && data.nextpagedate !== '') {
                    $scope.nextPages = true;
                    $scope.nextPageDate = data.nextpagedate;
                }
                else {
                    $scope.nextPages = false;
                    $scope.nextPageDate = '';
                }
            }, function (data, status) {
                logger.error('Problems fetching reminder log');
                //logger.error('ERROR: ' + data);
                //$scope.data = data || "Request failed";
                //$scope.status = status;
            });
            logger.debug('logs.ReminderLogsPaneController.fetchReminders() end');
        };
        $scope.notFirst = function ($index) {
            logger.debug('index=' + $index);
            return $index > 0;
        };
        /**
         * Select an appointment to highlight other appointments in same group
         */
        $scope.selectAppointment = function (appointment, index) {
            if ($scope.remindersModel.showMessageInfo) {
                $scope.remindersModel.selectedAppointment = appointment;
            }
        };
        // Filter reminders matching entered destinator address pattern
        // If not email then it's a phone number and the match will disregard any characters typically used
        // in phone numbers (dash, parentheses, hash, period, comma)
        $scope.reminderSearchFilter = function (searchReminder) {
            return function (reminder) {
                var destinator = searchReminder.destinator.trim();
                if (destinator === undefined || destinator === '') {
                    return reminder;
                }
                if (reminder.destinator.indexOf("@") > 0) {
                    // It's an email address
                    var searchRegx = new RegExp(destinator, "i");
                    if (reminder.destinator.search(searchRegx) !== -1) {
                        return reminder;
                    }
                }
                else {
                    // It's a phone number
                    var searchRegxNoSlashes = new RegExp(destinator.replace(/[\-\(\)\.\#\,]/g, ''), "i");
                    if (reminder.destinator.search(searchRegxNoSlashes) !== -1) {
                        return reminder;
                    }
                }
                return null;
            };
        };
        $scope.preview = function (messageUuid, mediaType, messageType) {
            storeDowngraded.dispatch(MessageActions.openMessagePreviewDialogJS({
                messageUuid: messageUuid,
                mediaType: mediaType,
                isTrackingcode: true,
                messageType: messageType
            }));
        };
        $scope.showAppointmentLog = function (reminder, dialogType) {
            var appointment = {
                appointmentTimeMs: reminder.appointmentdatems,
                firstName: reminder.profilename,
                uuid: reminder.uuid,
                appointmentId: reminder.appointmentid
            };
            storeDowngraded.dispatch(AppointmentListActions
                .openAppointmentLogsFromLogsJS({ appointment: appointment, dialogType: dialogType, selectedMessage: undefined, userTimeZone: accountService.currentUser.userTimeZone, userPermissionKeys: accountService.userPermissionKeys }));
        };
    }]);
/**
 * Controller for the message report tab
 */
app
    .controller('autoremind.logs.MessageReportController', 
// Setup dependencies
['$scope', '$http', '$filter', 'logger', 'userProfile', '$enhancedHttp',
    function ($scope, $http, $filter, logger, userProfile, $enhancedHttp) {
        // Initialization
        if (!angular.isDefined(userProfile.viewModel.views.logs.messagereport)) {
            // This is the first time opening the logs reminder view, so initialize
            userProfile.viewModel.views.logs.messagereport = {};
            userProfile.viewModel.views.logs.messagereport.messages = [];
            userProfile.viewModel.views.logs.messagereport.messages.search = {};
            userProfile.viewModel.views.logs.messagereport.messages.search.message = '';
            userProfile.viewModel.views.logs.messagereport.fetchState = {
                //"buttonLabel": "First Load",
                "busy": "false"
            };
        }
        // Map shared view model to this view
        $scope.messagereportModel = userProfile.viewModel.views.logs.messagereport;
        // Always get current day
        $scope.messagereportModel.fromDate = new Date(new Date().setDate(new Date().getDate() - 1));
        $scope.messagereportModel.toDate = new Date();
        // Listen for event on when tab is opened
        $scope.$on('tabChanged', function (scope, id) {
            if (id === 'messageLogTab') {
                logger.debug('logs.messageReportController should init now - if opened for the first time!');
                // Only load first time if message list is empty
                if ($scope.messagereportModel.messages.length === 0) {
                    logger.debug('logs.messageReportController fetching message report first');
                    $scope.fetchMessageReport();
                }
            }
        });
        // Functions
        /**
         * Open/close the 'from' date picker
         */
        $scope.toggleFromDatepicker = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.messagereportModel.fromDatepickerOpened = !$scope.messagereportModel.fromDatepickerOpened;
            // Make sure only one date picker is open
            if ($scope.messagereportModel.fromDatepickerOpened) {
                $scope.messagereportModel.toDatepickerOpened = false;
            }
        };
        /**
         * Open/close the 'to' date picker
         */
        $scope.toggleToDatepicker = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.messagereportModel.toDatepickerOpened = !$scope.messagereportModel.toDatepickerOpened;
            // Make sure only one date picker is open
            if ($scope.messagereportModel.toDatepickerOpened) {
                $scope.messagereportModel.fromDatepickerOpened = false;
            }
        };
        /**
         * Get message report from server
         */
        $scope.fetchMessageReport = function () {
            logger.debug('logs.messageReportController.fetchMessageReport() start');
            $scope.messagereportModel.fetchState.busy = true;
            $scope.messagereportModel.messages = []; // Clear list in UI
            var servletUrl = 'servlets/gateway/log/customer/?';
            servletUrl += "from=" + $scope.messagereportModel.fromDate.getTime() + "&to=" + $scope.messagereportModel.toDate.getTime();
            ;
            $enhancedHttp({ method: 'GET', url: servletUrl })
                .then(function (data, status) {
                logger.debug('logs.messageReportController.fetchMessageReport() got data from server');
                $scope.messagereportModel.fetchState.busy = false;
                for (var i = 0; i < data.lines.length; i++) {
                    //data.lines[i].timestamp = $filter('date')($filter('stringToDate')(data.lines[i].timestamp), 'MM/dd/yyyy hh:mm a' );
                    data.lines[i].timestamp = $filter('date')(data.lines[i].timestamp, 'MM/dd/yyyy hh:mm a', 'UTC');
                }
                $scope.messagereportModel.messages = data;
            }, function (data, status) {
                //logger.error('ERROR: ' + data);
                //$scope.data = data || "Request failed";
                $scope.status = status;
                //TODO: Handle error better
            });
            logger.debug('logs.messageReportController.fetchMessageReport() end');
        };
        /*
         * Used orderBy filter since it did not work just passing message.timestampms as ordering parameter
         */
        $scope.getTimestampMillis = function (message) {
            return message.timestampms;
        };
    }]);
app
    .controller('autoremind.logs.SystemCheckController', 
// Setup dependencies
['$scope', '$http', '$filter', 'logger', 'userProfile', 'dialogs', '$enhancedHttp', 'accountService',
    function ($scope, $http, $filter, logger, userProfile, dialogs, $enhancedHttp, accountService) {
        // Initialization
        if (!angular.isDefined(userProfile.viewModel.views.logs.systemcheck)) {
            // This is the first time opening the logs reminder view, so initialize
            userProfile.viewModel.views.logs.systemcheck = {};
            userProfile.viewModel.views.logs.systemcheck.template = '';
            userProfile.viewModel.views.logs.systemcheck.templateType = '';
            userProfile.viewModel.views.logs.systemcheck.templateLanguage = '';
            userProfile.viewModel.views.logs.systemcheck.templates = [];
            userProfile.viewModel.views.logs.systemcheck.search = { type: 'sms' }; // Preset UI
            userProfile.viewModel.views.logs.systemcheck.destinatorPhone = '';
            userProfile.viewModel.views.logs.systemcheck.destinatorEmail = '';
            userProfile.viewModel.views.logs.systemcheck.destinator = '';
            userProfile.viewModel.views.logs.systemcheck.fetchState = {
                "buttonLabel": "Reload template list",
                "busy": "false"
            };
            userProfile.viewModel.views.logs.systemcheck.sendState = {
                "buttonLabel": "Send Notification",
                "busy": "false" //NOTE: this is not yet used due to problems with ng-disabled testing multiple varibles, but it should at least be used to switch busy icon for the send button
            };
            userProfile.viewModel.views.logs.systemcheck.timezone = "";
            userProfile.viewModel.views.logs.systemcheck.lastSendError = "";
        }
        // Map shared view model to this view
        $scope.systemcheckModel = userProfile.viewModel.views.logs.systemcheck;
        // Listen for event on when tab is opened
        $scope.$on('tabChanged', function (scope, id) {
            if (id === 'checkSystemTab') { //NOTE: this is every time tab is opened
                logger.debug('logs.SystemCheckController tab selected - init if the first time!');
                if ($scope.systemcheckModel.templates.length === 0) {
                    // Only load templates if not loaded yet
                    if (userProfile.profileModel.templates.length === 0) {
                        // Get templates list on init
                        $scope.systemcheckModel.fetchState.buttonLabel = 'Loading...';
                        $scope.systemcheckModel.fetchState.busy = true;
                        userProfile.getProfile(function () {
                            logger.debug('SystemCheckController: got user profile');
                            $scope.systemcheckModel.templates = userProfile.profileModel.templates;
                            $scope.systemcheckModel.timezone = userProfile.profileModel.timezone;
                            $scope.selectFirstTemplate($scope.systemcheckModel.search.type);
                            $scope.systemcheckModel.fetchState.busy = false;
                            $scope.systemcheckModel.fetchState.buttonLabel = 'Reload templates list';
                            //console.log(JSON.stringify(userProfile.profileModel.templates, null, 4));
                            //$scope.notificationoffsets = userProfile.profileModel.notificationoffsets;
                            //console.log(JSON.stringify(userProfile.profileModel.notificationoffsets, null, 4));
                        });
                    }
                    else {
                        $scope.systemcheckModel.templates = userProfile.profileModel.templates;
                        $scope.systemcheckModel.timezone = userProfile.profileModel.timezone;
                        $scope.selectFirstTemplate($scope.systemcheckModel.search.type);
                        $scope.systemcheckModel.fetchState.busy = false;
                        //console.log(JSON.stringify(userProfile.profileModel.templates, null, 4));
                        //console.log(JSON.stringify(userProfile.profileModel.notificationoffsets, null, 4));
                    }
                }
            }
        });
        // Functions
        /*
         * Reloads the template list
         */
        $scope.reloadTemplates = function () {
            logger.debug('SystemCheckController: reloading templates');
            $scope.systemcheckModel.fetchState.buttonLabel = 'Loading...';
            $scope.systemcheckModel.fetchState.busy = true;
            userProfile.getProfile(function () {
                logger.debug('SystemCheckController: got user profile with templates');
                $scope.selectFirstTemplate($scope.systemcheckModel.search.type);
                $scope.systemcheckModel.fetchState.busy = false;
                $scope.systemcheckModel.fetchState.buttonLabel = 'Reload template list';
            });
        };
        /*
         * Selects (in the UI) the first template of the given type
         */
        $scope.selectFirstTemplate = function (type) {
            for (var i = 0; i < $scope.systemcheckModel.templates.length; i++) {
                if ($scope.systemcheckModel.templates[i].type === type) {
                    $scope.systemcheckModel.template = $scope.systemcheckModel.templates[i];
                    return;
                }
            }
        };
        /*
         * Used by UI as label for a template
         */
        $scope.templateLabel = function (template) {
            return '' + template.displayname + ' [' + template.type + ' (' + template.language + '): ' + template.name + ']';
        };
        /*
        * get updated phone value
        */
        $scope.systemcheckModel.onNumberChanged = function (event) {
            $scope.systemcheckModel.destinatorPhone = event;
        };
        /*
         * Sends a notification by scheduling a notification to be sent NOW
         */
        $scope.scheduleNotification = function () {
            logger.debug('logs.SystemCheckController.scheduleNotification() start');
            $scope.systemcheckModel.sendState.buttonLabel = 'Sending...';
            $scope.systemcheckModel.fetchState.busy = true;
            $scope.systemcheckModel.lastSendError = "";
            logger.debug('destinator type: ' + $scope.systemcheckModel.search.type);
            if ($scope.systemcheckModel.template.type === 'email') {
                $scope.systemcheckModel.destinator = $scope.systemcheckModel.destinatorEmail;
            }
            else {
                $scope.systemcheckModel.destinator = $scope.systemcheckModel.destinatorPhone;
            }
            var servletUrl = 'servlets/autoremind/send/?';
            // var appointmentDateTimeString = $filter('date')(new Date(), 'yyyy-MM-dd' ) + ' 23:55';
            var appointmentDateTimeString = 'today 23:55';
            servletUrl +=
                'destinator=' + encodeURIComponent($scope.systemcheckModel.destinator) +
                    '&appointmentdatetime=' + encodeURIComponent(appointmentDateTimeString) +
                    '&template=' + encodeURIComponent($scope.systemcheckModel.template.name) +
                    '&type=' + encodeURIComponent($scope.systemcheckModel.template.type) +
                    '&language=' + encodeURIComponent($scope.systemcheckModel.template.language) +
                    '&timezone=' + encodeURIComponent($scope.systemcheckModel.timezone) +
                    '&profilename=Test&profilelastname=Patient' +
                    '&resource=TestClinic' +
                    '&notificationoffsetid=-1' +
                    '&intervalstart=' + encodeURIComponent('00:01') +
                    '&intervalstop=' + encodeURIComponent('23:59') +
                    '&userId=' + encodeURIComponent(accountService.currentUser.userId);
            logger.debug('logs.SystemCheckController.scheduleNotification() url: ' + servletUrl);
            $enhancedHttp({ method: 'GET', url: servletUrl })
                .then(function (data, status) {
                logger.debug('logs.SystemCheckController.scheduleNotification() got data from server');
                $scope.systemcheckModel.sendState.buttonLabel = 'Send Notification';
                $scope.systemcheckModel.fetchState.busy = false;
                //$scope.status = status;
                //$scope.data = data;
                $scope.status = data;
                logger.debug('Send result: ' + data);
                if (data.error) {
                    $scope.systemcheckModel.lastSendError = data.error;
                }
                else {
                    $scope.systemcheckModel.lastSendError = "";
                    dialogs.notify('Success', 'Message successfully scheduled - expect delivery within a few minutes');
                }
            }, function (data, status) {
                //logger.error('ERROR: ' + data);
                //$scope.data = data || "Request failed";
                $scope.status = status;
            });
            logger.debug('logs.SystemCheckController.scheduleNotification() end');
        };
    }]);
//# sourceMappingURL=logs.controllers.js.map